<template>
  <div>
    <el-tabs style="margin-top: 3px" type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="csSpecialApplicationTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">申请编号：</td>
            <td>{{csSpecialApplication.billNo}}</td>
            <td class="tableLabel">申请人：</td>
            <td>{{csSpecialApplication.creatorName}}</td>
            <td class="tableLabel">申请时间：</td>
            <td> {{csSpecialApplication.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">申请标题：</td>
            <td>{{csSpecialApplication.title}}</td>
            <td class="tableLabel">紧急程度：</td>
            <td>
              <el-radio-group v-model="csSpecialApplication.urgency" disabled>
                <el-radio :label="10">一般</el-radio>
                <el-radio :label="20">较急</el-radio>
                <el-radio :label="30">特急</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">申请类型：</td>
            <td>
              <el-select v-model="csSpecialApplication.cause" disabled placeholder="请选择申请类型">
                <el-option
                    v-for="item in constant.toSelect(constant.specialApplicationCause)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">售后单号：</td>
            <td>{{csSpecialApplication.afterSaleNo}}</td>
            <td class="tableLabel">客户单号：</td>
            <td>{{csSpecialApplication.customerBillNo}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>{{csSpecialApplication.customerName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">出厂编号：</td>
            <td>{{csSpecialApplication.factorNo}}</td>
            <td class="tableLabel">电梯编号：</td>
            <td>{{csSpecialApplication.elevatorNo}}</td>
            <td class="tableLabel">项目名称：</td>
            <td>{{csSpecialApplication.projectName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">现场描述：</td>
            <td colspan="5">{{csSpecialApplication.siteDesc}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
      <el-table
          :data="csSpecialApplication.details">
        <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" placeholder="请输入">
              <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" align="center" label="物料名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialName" placeholder="请输入" autosize type="textarea"/>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" width="160" align="center" label="数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" width="100" align="center" label="单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" placeholder="请输入"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 12px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="csSpecialApplication.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants.js";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import DeliveryBillPrintOther from "@/views/afterSalesManagement/Replacement/DeliveryBillPrintOther";
  import ReplacementCopyEdit from "@/views/afterSalesManagement/Replacement/ReplacementCopyEdit";
  export default {
    name:"CsSpecialApplicationPreview",
    components:{HandleDetail},
    data() {
      return {
        constant,
        constants,
        applyTypes:constant.toSelect(constant.applyType),
        addSaleLoading:false,
        deliveryLoading:false,
        imgUrls: [],
        billId:"",
        billType:"32",
        pkid:"",
        csSpecialApplication: {
          pkid: "",
          billNo: "",
          afterSaleNo: "",
          title: "",
          customerBillNo: "",
          customerName: "",
          factorNo: "",
          elevatorNo: "",
          projectName: "",
          urgency: 10,
          cause: "",
          details:[],
          attachments:[],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.csSpecialApplication={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`csSpecialApplications/${this.billId}`).then((res)=>{
          this.csSpecialApplication = res;
          this.csSpecialApplication.attachments.forEach(row=>{
            if(row.filePath.includes("common")) {
              row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
              this.imgUrls.push(row.imgUrl);
            }else {
              row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
              this.imgUrls.push(row.imgUrl);
            }
          });
        }).catch(()=>{
        });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      getDetails(row,index) {
        this.csSpecialApplication.details[index].materialId = row.id;
        this.csSpecialApplication.details[index].materialName = row.name;
        this.csSpecialApplication.details[index].materialNo = row.no;
      },
      downLoad(row) {
        if(row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
table.csSpecialApplicationTable {
  font-family: verdana,arial,sans-serif;
  font-size:12px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.csSpecialApplicationTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.csSpecialApplicationTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 12%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
